module.exports = __webpack_public_path__ + "img/about.435e3c74.png";